import root from './reducers/root'
import { createStore } from 'redux'

const store = createStore(root)

export default store
